const AUTH_REDIRECT_STORAGE_KEY = "expense-admin-auth-redirect";

function isInternalPath(path: string): boolean {
    return path.startsWith("/") && !path.startsWith("//");
}

export function saveAuthRedirect(path: string): void {
    if (!isInternalPath(path)) return;

    try {
        sessionStorage.setItem(AUTH_REDIRECT_STORAGE_KEY, path);
    } catch {
        return;
    }
}

export function consumeAuthRedirect(): string | null {
    try {
        const path = sessionStorage.getItem(AUTH_REDIRECT_STORAGE_KEY);
        sessionStorage.removeItem(AUTH_REDIRECT_STORAGE_KEY);
        return path && isInternalPath(path) ? path : null;
    } catch {
        return null;
    }
}
